import { Spin, SpinProps } from "antd";
import "./style/index.scss";

const NormalSpin = (props: SpinProps) => {
  const { size, delay, spinning, tip, children, indicator, ...rest } = props;
  return (
    <div className="spinContainer">
      <Spin size={size} delay={delay} spinning={spinning} tip={tip} indicator={indicator} {...rest}>
        {children}
      </Spin>
    </div>
  );
};
export default NormalSpin;
